import React from 'react'
import KomatsuCreditHistory from "./komatsucredithistory";
import { RESOURCE } from '../../../const/resource';
import { useTranslation } from "react-i18next";
import helperfunctions from '../../../utils/helperfunctions';


const TotalCreditFormat = (item: any) => {
    return (<td><span className="float-right">{getNumericValueFormat(item.dataItem.totalCredit ??0)}</span></td>)
}

const RemainingCreditFormat = (item: any) => {
    return (<td><span className="float-right">{getNumericValueFormat(item.dataItem.remainingCredit??0)}</span></td>)
}

const getNumericValueFormat = (value: any) => {
    const formatedvalue = helperfunctions.formatAmount(value ?? 0);
    return (value >= 0 ? `$${formatedvalue}` : `$(${formatedvalue?.replace("-", '')})`);
}

const KomatsuCreditHistoryContainer = () => {
    const { t } = useTranslation();
    const columns = [
        {
            field: 'creditName',
            title: t(RESOURCE.MyK_Label_SC_KCH_CreditName),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
        },
        {
            field: "creditUsage",
            title: t(RESOURCE.MyK_Label_SC_KCH_CreditUsage),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
        },
        {
            field: 'totalCredit',
            title: t(RESOURCE.MyK_Label_SC_KCH_TotalCredit),
            sortable: true,
            filterable: true,
            filter: "numeric",
            columnMenu: 'ColumnMenu',
            cell: TotalCreditFormat
        },
        {
            field: 'remainingCredit',
            title: t(RESOURCE.MyK_Label_SC_KCH_RemainingBalance),
            sortable: true,
            filterable: true,
            filter: "numeric",
            columnMenu: 'ColumnMenu',
            cell:RemainingCreditFormat
        },
        {
            field: 'validity',
            title: t(RESOURCE.MyK_Label_Duration),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'status',
            title: t(RESOURCE.Myk_Label_OrderHistory_Status),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'model',
            title: t(RESOURCE.MyK_Label_Model),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'serial',
            title: t(RESOURCE.MyK_Label_Serial) + " #",
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu',
        },
        {
            field: 'orderDate',
            title: t(RESOURCE.MyK_Label_SC_KCH_PurchaseDate),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu',
            format: "{0: MM/dd/yyyy}",
            type: "date",
            filter: "date"
        },
    ]

    const exportColumns = [
        {
            field: 'creditName',
            title: t(RESOURCE.MyK_Label_SC_KCH_CreditName)
        },
        {
            field: "creditUsage",
            title: t(RESOURCE.MyK_Label_SC_KCH_CreditUsage)
        },
        {
            field: 'totalCreditExport',
            title: t(RESOURCE.MyK_Label_SC_KCH_TotalCredit)
        },
        {
            field: 'remainingCreditExport',
            title: t(RESOURCE.MyK_Label_SC_KCH_RemainingBalance)
        },
        {
            field: 'validity',
            title: t(RESOURCE.MyK_Label_Duration)
        },
        {
            field: 'status',
            title: t(RESOURCE.Myk_Label_OrderHistory_Status)
        },
        {
            field: 'model',
            title: t(RESOURCE.MyK_Label_Model)
        },
        {
            field: 'serial',
            title: t(RESOURCE.MyK_Label_Serial) + " #"
        },
        {
            field: 'orderDate',
            title: t(RESOURCE.MyK_Label_SC_KCH_PurchaseDate)
        },
    ]


    return (
        <KomatsuCreditHistory columns={columns} exportColumns={exportColumns} />
    )
}

export default KomatsuCreditHistoryContainer